import React from "react";

export default function BrazilianCarnivalFrame4({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-4br2{fill:#efd725}.cls-4br3{fill:#8e2dba}.cls-4br4{fill:#ed26ab}"
            }
          </style>
        </defs>
        <path
          d="M442.21 532.04v1269h1120.21v-1269H442.21Zm851.1 325.94c23.96 0 45.96 8.42 63.18 22.47 22.48 18.34 36.84 46.27 36.84 77.55v570.89c0 33.38-16.35 62.95-41.49 81.11-16.46 11.9-36.68 18.9-58.53 18.9H722.42c-25.63 0-49-9.64-66.7-25.5-20.45-18.31-33.32-44.91-33.32-74.52V957.99c0-27.47 11.08-52.36 29.02-70.44 18.13-18.27 43.24-29.58 71-29.58h570.89Z"
          className="cls-4br3"
        />
        <path
          d="M1393.33 958v570.89c0 33.38-16.35 62.95-41.49 81.11-16.46 11.9-36.68 18.9-58.53 18.9H722.42c-25.63 0-49-9.64-66.7-25.5-20.45-18.31-33.32-44.91-33.32-74.52V957.99c0-27.47 11.08-52.36 29.02-70.44 18.13-18.27 43.24-29.58 71-29.58h570.89c23.96 0 45.96 8.42 63.18 22.47 22.48 18.34 36.84 46.27 36.84 77.55Z"
          style={{
            fill: "#fff",
          }}
        />
        <path
          d="M1562.43 532.33v153.23c-116.28 44.29-307.85 101.48-550.61 103.82-252.18 2.42-451.24-55.39-569.61-99.4V532.04c373.41.1 746.81.19 1120.21.29Z"
          style={{
            fill: "#b35ae2",
          }}
        />
        <ellipse
          cx={1000}
          cy={532.05}
          className="cls-4br2"
          rx={562.42}
          ry={159.87}
        />
        <ellipse
          cx={1000}
          cy={518.9}
          className="cls-4br4"
          rx={384.13}
          ry={97.84}
        />
        <path
          d="M995.47 1897.7c-42.38 0-178.47-1.51-360.87-36.86-49.94-9.68-115.6-24.28-191.89-46.54-.17-44.18-.33-88.35-.5-132.53 130.37 40.57 328.2 86.33 571.91 83.94 232.36-2.28 421.28-47.5 548.3-88.08v123.42c-191.02 70.98-338.54 93.71-542.84 96.5-8.04.11-16.08.16-24.12.16Z"
          className="cls-4br2"
        />
        <path
          d="M442.21 855.11c15.33 27.77 24.45 76.34 38.37 108.8-13.93 32.48-23.04 81.03-38.37 108.78V855.11ZM545.73 963.86c-8.34 19.47-18.41 33.16-32.58 33.16s-24.22-13.67-32.56-33.1c8.34-19.47 18.41-33.16 32.58-33.16s24.22 13.67 32.56 33.1Z"
          className="cls-4br4"
        />
        <path
          d="M651.42 887.57c-17.93 18.08-29.02 42.97-29.02 70.44v132.96c-3.46 2.1-7.22 3.25-11.32 3.25-34.81 0-44.86-82.59-65.36-130.35 20.47-47.77 30.55-130.31 65.34-130.31 18.85 0 30.44 24.22 40.36 54.02ZM835.4 857.98h-57.01c7.54-14.71 16.57-24.43 28.51-24.43s20.96 9.73 28.5 24.43ZM1031.23 857.98h-57.02c7.54-14.71 16.57-24.43 28.51-24.43s20.97 9.73 28.51 24.43ZM1227.08 857.98h-57.03c7.54-14.71 16.57-24.43 28.51-24.43s20.98 9.73 28.52 24.43ZM1459.76 963.9c-20.47 47.77-30.55 130.31-65.34 130.31-.37 0-.73-.01-1.09-.02V958c0-31.27-14.36-59.21-36.84-77.55 9.39-26.45 20.6-46.91 37.91-46.91 34.81 0 44.86 82.59 65.36 130.35ZM1524.9 963.86c-8.34 19.47-18.41 33.16-32.58 33.16s-24.22-13.67-32.56-33.1c8.34-19.47 18.41-33.16 32.58-33.16s24.22 13.67 32.56 33.1ZM1562.43 856.64v214.44c-14.83-28-23.86-75.36-37.53-107.22 13.67-31.88 22.7-79.24 37.53-107.21ZM442.21 1431.77c15.33 27.77 24.45 76.33 38.37 108.79-13.93 32.48-23.04 81.03-38.37 108.78v-217.57ZM545.73 1540.52c-8.34 19.47-18.41 33.16-32.58 33.16s-24.23-13.67-32.56-33.11c8.34-19.47 18.41-33.16 32.58-33.16s24.23 13.67 32.56 33.11Z"
          className="cls-4br4"
        />
        <path
          d="M655.72 1603.41c-10.95 35.59-23.02 67.45-44.64 67.45-34.79 0-44.86-82.57-65.36-130.34 20.47-47.76 30.55-130.3 65.34-130.3 4.11 0 7.87 1.15 11.34 3.26v115.41c0 29.62 12.87 56.22 33.32 74.52ZM843.03 1628.91c-9.03 23.99-19.89 41.95-36.1 41.95s-27.06-17.94-36.1-41.95h72.21ZM1038.86 1628.91c-9.03 23.99-19.89 41.95-36.1 41.95s-27.08-17.96-36.1-41.95h72.21ZM1234.69 1628.91c-9.02 24.01-19.87 41.95-36.09 41.95s-27.08-17.96-36.1-41.95h72.2ZM1459.76 1540.56c-20.47 47.76-30.55 130.3-65.34 130.3-20.27 0-32.14-28.01-42.58-60.85 25.13-18.16 41.49-47.73 41.49-81.11v-118.65c.35-.01.71-.02 1.07-.02 34.8 0 44.86 82.58 65.36 130.34ZM1524.9 1540.52c-8.34 19.47-18.41 33.16-32.58 33.16s-24.22-13.67-32.56-33.11c8.34-19.47 18.41-33.16 32.58-33.16s24.22 13.67 32.56 33.11ZM1562.43 1433.3v214.42c-14.83-28-23.86-75.35-37.53-107.21 13.67-31.88 22.7-79.24 37.53-107.21ZM442.21 1229.09c7.76 8.84 14.14 19.77 21.2 29.69-7.04 9.92-13.42 20.85-21.2 29.69v-59.37ZM549.09 1258.76c-10.51 14.76-22.5 27.27-42.85 27.27s-32.33-12.5-42.83-27.26c10.51-14.76 22.51-27.27 42.85-27.27s32.33 12.5 42.83 27.26Z"
          className="cls-4br4"
        />
        <path
          d="M622.4 1215.02v87.49c-4.95 2.16-10.53 3.4-16.93 3.4-29.28 0-41.27-25.91-56.39-47.14 15.1-21.24 27.1-47.14 56.36-47.14 6.41 0 11.99 1.24 16.95 3.4ZM1455.55 1258.77c-15.1 21.24-27.1 47.14-56.36 47.14-2.03 0-3.98-.12-5.86-.37v-93.55c1.86-.24 3.8-.36 5.84-.36 29.28 0 41.27 25.91 56.39 47.14Z"
          className="cls-4br4"
        />
        <path
          d="M1541.23 1258.76c-10.51 14.76-22.5 27.27-42.85 27.27s-32.33-12.5-42.83-27.26c10.51-14.76 22.51-27.27 42.85-27.27s32.33 12.5 42.83 27.26Z"
          className="cls-4br4"
        />
        <rect
          width={441.29}
          height={48.14}
          x={1053}
          y={225.04}
          className="cls-4br4"
          rx={24.07}
          ry={24.07}
          transform="rotate(-38.64 1273.578 249.118)"
        />
        <path
          d="M1562.43 1229.08v59.37c-7.76-8.84-14.14-19.77-21.2-29.69 7.04-9.92 13.42-20.85 21.2-29.69Z"
          className="cls-4br4"
        />
        <circle cx={1119.2} cy={371.56} r={91.92} className="cls-4br3" />
        <rect
          width={441.29}
          height={48.14}
          x={561.09}
          y={292.96}
          className="cls-4br4"
          rx={24.07}
          ry={24.07}
          transform="rotate(-132.71 781.76 317.011)"
        />
        <circle cx={915.92} cy={462.38} r={91.92} className="cls-4br3" />
        {children}
      </g>
    </svg>
  );
}
